import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddClausuradoForm() {
    const [formData, setFormData] = useState({
        id: '',
        cementerioId: '1',
        fecha: '',
        observaciones: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post(`/clausurados/${formData.id}`, {
                    cementerioId: parseInt(formData.cementerioId, 10),
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || ''
                });
                navigate('/home/clausurados');
            } catch (err) {
                console.error('Error saving clausurado:', err);
                setErrors({ submit: 'Error al guardar el clausurado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">Añadir Nuevo Clausurado</h2>
            <form onSubmit={handleSubmit} className="bg-blue-100 shadow-md rounded-lg px-10 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">Id sepultura a clausurar</label>
                        <input
                            type="text"
                            name="id"
                            value={formData.id}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                            placeholder="Ingrese el ID"
                        />
                        {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">Cementerio ID</label>
                        <input
                            type="text"
                            name="cementerioId"
                            value={formData.cementerioId}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
                            placeholder="Ingrese el Cementerio ID"
                        />
                        {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">Fecha</label>
                        <input
                            type="date"
                            name="fecha"
                            value={formData.fecha}
                            onChange={handleChange}
                            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
                        />
                        {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">Observaciones</label>
                        <textarea
                            name="observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            placeholder="Ingrese observaciones"
                        />
                    </div>
                </div>
                <div className="mt-6 flex justify-center">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Clausurado'}
                    </button>
                </div>
            </form>
        </div>
    );
}

/*
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';

export default function AddClausuradoForm() {
    const [formData, setFormData] = useState({
        id: '',
        cementerioId: '',
        fecha: '',
        observaciones: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación básica
        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.cementerioId) validationErrors.cementerioId = 'El campo Cementerio ID es obligatorio.';
        if (!formData.fecha) validationErrors.fecha = 'El campo Fecha es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post(`/clausurados/${formData.id}`, {
                    cementerioId: parseInt(formData.cementerioId, 10),
                    fecha: formData.fecha,
                    observaciones: formData.observaciones || ''
                });
                navigate('/home/clausurados');
            } catch (err) {
                console.error('Error saving clausurado:', err);
                setErrors({ submit: 'Error al guardar el clausurado. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nuevo Clausurado</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
                        ID
                    </label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                        placeholder="Ingrese el ID"
                    />
                    {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cementerioId">
                        Cementerio ID
                    </label>
                    <input
                        type="text"
                        name="cementerioId"
                        value={formData.cementerioId}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.cementerioId ? 'border-red-500' : ''}`}
                        placeholder="Ingrese el Cementerio ID"
                    />
                    {errors.cementerioId && <p className="text-red-500 text-xs italic">{errors.cementerioId}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fecha">
                        Fecha
                    </label>
                    <input
                        type="date"
                        name="fecha"
                        value={formData.fecha}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.fecha ? 'border-red-500' : ''}`}
                    />
                    {errors.fecha && <p className="text-red-500 text-xs italic">{errors.fecha}</p>}
                </div>
                
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="observaciones">
                        Observaciones
                    </label>
                    <textarea
                        name="observaciones"
                        value={formData.observaciones}
                        onChange={handleChange}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        placeholder="Ingrese observaciones"
                    />
                </div>
                
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Clausurado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/